import { FavoriteBorderOutlined, SearchOutlined, ShoppingCartOutlined } from '@material-ui/icons';
import React from 'react';

const Product = ({ product, onChangePage }) => {
  return (
    <div className="flex flex-1 items-center justify-center min-w-[250px] min-h-[350px] overflow-hidden rounded-md shadow-lg relative">
      <img src={product.src} alt="top_product_image" />
      <div className="flex justify-center items-center w-full h-full absolute gap-6 opacity-0 hover:opacity-100 hover:bg-[rgba(0,0,0,0.2)] ease-in duration-100">
        <div className="styleIconTopProduct" onClick={() => onChangePage('CartPage')}>
          <ShoppingCartOutlined />
        </div>
        <div className="styleIconTopProduct">
          <FavoriteBorderOutlined />
        </div>
        <div className="styleIconTopProduct" onClick={() => onChangePage('ProductPage')}>
          <SearchOutlined />
        </div>
      </div>
    </div>
  );
};

export default Product;
